import { Component } from '@angular/core';
import { Pagination } from 'src/app/shared/models';
import { Contrato, ContratoService } from 'src/app/contrato';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { AuthService } from 'src/app/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr, formatHumanTime } from 'src/app/shared/utils';
import { FaturamentoService } from '../faturamento.service';
import { Faturamento, FaturamentoEquipamento, FaturamentoTotal } from '../faturamento.model';
import { CurrencyPipe } from '@angular/common';
import dayjs from 'dayjs';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { RelatorioService } from 'src/app/relatorio/relatorio.service';
import { C } from '@angular/cdk/scrolling-module.d-ud2XrbF8';

@Component({
    selector: 'app-view-faturamento',
    templateUrl: './view-faturamento.component.html',
    providers: [CurrencyPipe],
    standalone: false
})
export class ViewFaturamentoComponent {

    loading: boolean;
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 }
    showEdit: boolean;

    faturamentoId: string;
    contratos: Pagination<Contrato>;
    faturamento: Faturamento;
    justificativaReabertura: string;
    totalizadores: FaturamentoTotal;
    dataSource: FaturamentoEquipamento[];

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Faturamentos', route: '/faturamentos' },
        { label: 'Visualizar faturamento' },
    ]

    columns: GenerateTableColumn[] = [
        { header: 'Equipamento', attr: 'alocacaoCodigo' },
        { header: 'Placa/Série', attr: 'equipamentoPlaca' },
        { header: 'Hora Disp', attr: 'totalHorasDisponiveisEmMinutos' },
        { header: 'Hora Trab', attr: 'totalHorasFuncionamentoEmMinutos' },
        { header: 'Km', attr: 'totalKmRodados' },
        {
            header: 'Custo',
            template: (rowData: FaturamentoEquipamento) => `
                <div>${rowData.custo}</div>
                ${this.showEdit ? `
                    <div class="text-primary">${rowData.valorReajustado ? this.currencyPipe.transform(rowData.valorReajustado, 'BRL') : '---'}</div>
                    <div class="text-success">${rowData.diferenca ? this.currencyPipe.transform(rowData.diferenca, 'BRL') : '---'}</div>
                `: ``}`
        },
        { header: 'Qtde DIOs', attr: 'dios' },     
    ]

    constructor(
        public authService: AuthService,
        private currencyPipe: CurrencyPipe,
        private activatedRoute: ActivatedRoute,
        private faturamentoService: FaturamentoService,
        private contratoService: ContratoService,
        private relatorioService: RelatorioService,
        private snackBar: MatSnackBar,
        private router: Router
    ) { }

    ngOnInit() {
        this.loading = true;
        this.faturamentoId = this.activatedRoute.snapshot.params['idFaturamento'];
        this.faturamentoService.getById<Faturamento>(this.faturamentoId).subscribe({
            next: (res) => { 
                this.faturamento = res;

                const contratoId = this.faturamento.contrato.id;
                const dataBaseInicio = this.faturamento.dataBaseInicio;
                const dataBaseFim = this.faturamento.dataBaseFim;

                this.contratoService.getFaturamento(contratoId, dataBaseInicio, dataBaseFim).subscribe({
                    next: (resFaturamentos) => {
                        this.dataSource = resFaturamentos.equipamentos.map((item) => this.buildResponse(item));
                        this.totalizadores = resFaturamentos.total;
                    },
                    error: (err) => catchErr(err, this.snackBar)
                });
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    search(pageEvent?: GenerateTablePageEvent) {
        this.loading = false;
        console.log('clicou search');
    }

    reabrir() {
        this.loading = true;
        this.faturamentoService.reabrirFaturamento(this.faturamentoId, this.justificativaReabertura).subscribe({
            next: (res: any) => {
                this.faturamento.status = res.faturamento.status;
                this.snackBar.open('Faturamento reaberto com sucesso!', 'X', { duration: 4000, panelClass: ['success']  });

                this.router.navigate(['/relatorio/faturamentos']);
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    fechar() {
        this.loading = true;
        this.faturamentoService.fecharFaturamento(this.faturamentoId).subscribe({
            next: (res: any) => {
                this.faturamento.status = res.faturamento.status;
                this.snackBar.open('Faturamento fechado com sucesso!', 'X', { duration: 4000, panelClass: ['success']  });

                this.router.navigate(['/relatorio/faturamentos']);
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    private buildResponse(item: FaturamentoEquipamento) {
        return {
            ...item,
            custo: this.currencyPipe.transform(item.custo, 'BRL'),
            totalHorasDisponiveisEmMinutos: formatHumanTime(item.totalHorasDisponiveisEmMinutos),
            totalHorasFuncionamentoEmMinutos: formatHumanTime(item.totalHorasFuncionamentoEmMinutos),
            totalKmRodados: `${item.totalKmRodados} km`,
        }
    }

    print() {
        window.print();
    }

    export(format: string) {
        this.loading = true;
        const filters = {             
            contratoId: this.faturamento.contrato.id,
            dataInicio: `${dayjs(this.faturamento.dataBaseInicio).format('YYYY-MM-DD')}T00:00:00`, 
            dataFim: `${dayjs(this.faturamento.dataBaseFim).format('YYYY-MM-DD')}T23:59:59`, 
            removePaingation: true 
        };

        console.log('filters', filters);
        console.log('format', format);
        console.log('faturamento', this.faturamento);

        this.relatorioService.downloadArquivoCsvOrPdf(filters, `faturamentos/${this.faturamento.id}`, format).subscribe({
            next: (res: any) => {
            const url = window.URL.createObjectURL(res.body as Blob);
            const startReport = filters.dataInicio ? dayjs(filters.dataInicio).format('DD-MM-YYYY') : dayjs().format('DD-MM-YYYY')
            const endReport = filters.dataFim ? dayjs(filters.dataFim).format('DD-MM-YYYY') : dayjs().format('DD-MM-YYYY')
            const fileName = `Relatorio_Faturamento_${startReport}_ate_${endReport}`
            const anchor = document.createElement("a");
            anchor.download = `${fileName}.${format}`;
            anchor.href = url;
            anchor.click();
            this.loading = false;
            }, error: (err: HttpErrorResponse) => {
            this.loading = false;
            catchErr(err, this.snackBar)
            }
        });
    }

}
